import React from 'react';
import type { RealtimeEngineConfig } from '../../services/api';
import { normalizeRealtimeEngineConfig, REALTIME_ALERT_LABELS, REALTIME_ALERT_LEVELS, REALTIME_RUBRIC_MAX_LENGTH } from '../../features/realtime/config';
import './RealtimeAlertRubric.css';

const RealtimeAlertRubric: React.FC<{
  value?: RealtimeEngineConfig | null;
  onChange?: (value: RealtimeEngineConfig) => void;
  compact?: boolean;
}> = ({ value, onChange, compact = false }) => {
  const config = normalizeRealtimeEngineConfig(value);
  return <div className={`realtime-alert-rubric${compact ? ' is-compact' : ''}`} aria-label="Alert rubric">
    {REALTIME_ALERT_LEVELS.map(level => <div key={level} className={`realtime-alert-rubric-item realtime-alert-${level}`}>
      <span className="realtime-alert-tag">{REALTIME_ALERT_LABELS[level]}</span>
      {onChange ? <textarea aria-label={`${REALTIME_ALERT_LABELS[level]} alert rubric`} value={config.alert_rubric[level]}
        maxLength={REALTIME_RUBRIC_MAX_LENGTH} rows={3} onChange={event => onChange({ alert_rubric: { ...config.alert_rubric, [level]: event.target.value } })} />
        : <p>{config.alert_rubric[level]}</p>}
    </div>)}
  </div>;
};

export default RealtimeAlertRubric;
